/** True when the API says the partner is turned off. */
export function isPartnerNotEnabledError(error: unknown): boolean {
    if (!error || typeof error !== 'object') {
        return false
    }

    const responseData = (error as { response?: { data?: { errors?: { is_partner_disabled?: boolean }[] } } }).response?.data
    return responseData?.errors?.[0]?.is_partner_disabled === true
}
